import adaptiveDirectionalityOn from '../static/videos/AdaptiveDirectionalityON.mp4';
import adaptiveDirectionalityOff from '../static/videos/AdaptiveDirectionalityOFF.mp4';
import binauralNoiseManagementOn from '../static/videos/BinauralNoiseManagementON.mp4';
import binauralNoiseManagementOff from '../static/videos/BinauralNoiseManagementOFF.mp4';
import bluetoothOn from '../static/videos/bluetoothON.mp4';
import bluetoothOff from '../static/videos/bluetoothOFF.mp4';
import fixedDirectionalityOn from '../static/videos/FixedDirectionalityON.mp4';
import fixedDirectionalityOff from '../static/videos/FixedDirectionalityOFF.mp4';
import multibandAdaptiveDirectionalityOn from '../static/videos/MultibandAdaptiveDirectionalityON.mp4';
import multibandAdaptiveDirectionalityOff from '../static/videos/MultibandAdaptiveDirectionalityOFF.mp4';
import spatialGuardOn from '../static/videos/SpatialGuardON.mp4';
import spatialGuardOff from '../static/videos/SpatialGuardOFF.mp4';
import speechGuardOn from '../static/videos/SpeechGuardON.mp4';
import speechGuardOff from '../static/videos/SpeechGuardOFF.mp4';

const defaultList = [{
  key: 'fixedDirectionality',
  name: '固定指向性麥克風',
  videoOn: fixedDirectionalityOn,
  videoOff: fixedDirectionalityOff,
}, {
  key: 'multibandAdaptiveDirectionality',
  name: '多頻帶適應性方向性麥克風',
  videoOn: multibandAdaptiveDirectionalityOn,
  videoOff: multibandAdaptiveDirectionalityOff,
}, {
  key: 'spatialGuard',
  name: '空間立體音',
  videoOn: spatialGuardOn,
  videoOff: spatialGuardOff,
}, {
  key: 'bluetooth',
  name: '藍牙功能',
  videoOn: bluetoothOn,
  videoOff: bluetoothOff,
}, {
  key: 'speechGuard',
  name: '語音守護',
  videoOn: speechGuardOn,
  videoOff: speechGuardOff,
}, {
  key: 'adaptiveDirectionality',
  name: '適應性方向性麥克風',
  videoOn: adaptiveDirectionalityOn,
  videoOff: adaptiveDirectionalityOff,
}, {
  key: 'binauralNoiseManagement',
  name: '雙耳噪音管理',
  videoOn: binauralNoiseManagementOn,
  videoOff: binauralNoiseManagementOff,
}];

export default (state = {
  list: defaultList,
}, action) => {
  switch (action.type) {

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/Specification.js